import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  DetailsSkeleton,
  InputSkeleton,
  RiskSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemTablet: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const middleInfos = [
    { label: 'Tipo', value: <TextSkeleton w="60%" /> },
    { label: 'Rent. 12 meses', value: <TextSkeleton w="60%" /> },
    { label: 'Taxa admin.', value: <TextSkeleton w="60%" /> },
    { label: 'Resgate', value: <TextSkeleton w="60%" /> },
    { label: 'Risco unitário', value: <RiskSkeleton /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center" w="full">
          <TextSkeleton w="60%" hasCaptions />
          <DetailsSkeleton />
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between" w="full">
          <VStack space={Spacing['stack.quarck']} w="60%">
            <UI.Text color="neutral.black" variant="semibold">
              Aplicação mínima:
            </UI.Text>
            <InputSkeleton />
          </VStack>
          <Stack alignSelf="flex-end" w="10%">
            <ButtonSkeleton borderRadius={BoxBorder.thick} />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
